<div class="shared-ui-checkbox shared-ui-control" *ngIf="control">
  <label for="chkBox" class="fwform-label">{{ label }}</label>
  <input type="checkbox" name="chkbox" [formControl]="control" />
  <ngb-alert *ngIf="control.errors" [dismissible]="false">
    <div class="shared-ui-checkbox-val-error" *ngFor="let error of control.errors | validationErrorKeys">{{messages[error]}}</div>
  </ngb-alert>
</div>

